// Restored from production OTA 2026-08-21 (module 1417). All Google calls go
// through the one /googleapi function; the previous per-call endpoints
// (googleapis-autocomplete, ...) and hardcoded username/password are gone.
import base64 from 'react-native-base64';
import { firebase } from '../config/configureFirebase';
import AppCat from '../config/AppCat';

const callGoogleApi = (body) => {
    const { config } = firebase;
    return fetch(`https://${config.projectId}.web.app/googleapi`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            "Authorization": "Basic " + base64.encode(config.projectId + ":" + AppCat)
        },
        body: JSON.stringify(body)
    }).then((response) => response.json());
};

export const fetchPlacesAutocomplete = (searchKeyword) => {
    return new Promise((resolve, reject) => {
        callGoogleApi({ searchKeyword })
            .then((json) => {
                if (json && json.searchResults) {
                    resolve(json.searchResults);
                } else {
                    reject(json.error);
                }
            })
            .catch((error) => {
                console.log(error);
                reject("fetchPlacesAutocomplete Call Error");
            });
    });
};

export const fetchCoordsfromPlace = (place_id) => {
    return new Promise((resolve, reject) => {
        callGoogleApi({ place_id })
            .then((json) => {
                if (json && json.coords) {
                    resolve(json.coords);
                } else {
                    reject(json.error);
                }
            })
            .catch((error) => {
                console.log(error);
                reject("fetchCoordsfromPlace Call Error");
            });
    });
};

export const fetchAddressfromCoords = (latlng) => {
    return new Promise((resolve, reject) => {
        callGoogleApi({ latlng })
            .then((json) => {
                if (json && json.address) {
                    resolve(json.address);
                } else {
                    reject(json.error);
                }
            })
            .catch((error) => {
                console.log(error);
                reject("fetchAddressfromCoords Call Error");
            });
    });
};

export const getDistanceMatrix = (startLoc, destLoc) => {
    return new Promise((resolve, reject) => {
        callGoogleApi({ start: startLoc, dest: destLoc, calltype: 'matrix' })
            .then((json) => {
                if (json.error) {
                    console.log(json.error);
                    reject(json.error);
                } else {
                    resolve(json);
                }
            })
            .catch((error) => {
                console.log(error);
                reject("getDistanceMatrix Call Error");
            });
    });
};

export const getDirectionsApi = (startLoc, destLoc, waypoints) => {
    return new Promise((resolve, reject) => {
        const body = { start: startLoc, dest: destLoc, calltype: 'direction' };
        if (waypoints) {
            body.waypoints = waypoints;
        }
        callGoogleApi(body)
            .then((json) => {
                if (json.hasOwnProperty('distance_in_km')) {
                    resolve(json);
                } else {
                    console.log(json.error);
                    reject(json.error);
                }
            })
            .catch((error) => {
                console.log(error);
                reject("getDirectionsApi Call Error");
            });
    });
};
